/* Wander Painting — before/after comparison slider.
   A range input drives the reveal, so keyboard and assistive tech work without
   extra handling; pointer events just write the same input's value. */
(function () {
  'use strict';

  var ATTR = 'data-wp-ba';

  function BeforeAfter(root) {
    this.root = root;
    this.range = root.querySelector('.wp-ba__range');
    this.overlay = root.querySelector('.wp-ba__overlay');
    this.overlayImg = this.overlay ? this.overlay.querySelector('img') : null;
    if (!this.range || !this.overlay || !this.overlayImg) return;

    this.onInput = this.onInput.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.syncWidth = this.syncWidth.bind(this);

    this.range.addEventListener('input', this.onInput);
    this.root.addEventListener('pointerdown', this.onPointerDown);

    // The clipped image is absolutely positioned, so it needs an explicit width
    // matching the container or it collapses as the overlay narrows.
    if ('ResizeObserver' in window) {
      this.observer = new ResizeObserver(this.syncWidth);
      this.observer.observe(this.root);
    } else {
      window.addEventListener('resize', this.syncWidth);
    }

    this.syncWidth();
    this.apply(parseFloat(this.range.value));
    root.setAttribute(ATTR + '-ready', 'true');
  }

  BeforeAfter.prototype.syncWidth = function () {
    this.overlayImg.style.width = this.root.clientWidth + 'px';
  };

  BeforeAfter.prototype.apply = function (pct) {
    var clamped = Math.max(0, Math.min(100, pct));
    this.root.style.setProperty('--wp-ba-pos', clamped + '%');
    // The same value again as a plain 0-1 number. A percentage cannot be used
    // in an opacity calculation, so anything that wants to fade something as
    // the divider travels - the labels, for instance - needs this form.
    // Purely additive: nothing breaks if a stylesheet ignores it.
    this.root.style.setProperty('--wp-ba-n', clamped / 100);
    this.range.setAttribute('aria-valuetext', Math.round(clamped) + '% revealed');
  };

  BeforeAfter.prototype.onInput = function () {
    this.apply(parseFloat(this.range.value));
  };

  BeforeAfter.prototype.positionFromEvent = function (event) {
    var rect = this.root.getBoundingClientRect();
    if (!rect.width) return null;
    return ((event.clientX - rect.left) / rect.width) * 100;
  };

  BeforeAfter.prototype.onPointerDown = function (event) {
    var pct = this.positionFromEvent(event);
    if (pct === null) return;
    this.dragging = true;
    this.pointerId = event.pointerId;
    this.range.value = pct;
    this.apply(pct);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
  };

  BeforeAfter.prototype.onPointerMove = function (event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    var pct = this.positionFromEvent(event);
    if (pct === null) return;
    event.preventDefault();
    this.range.value = pct;
    this.apply(pct);
  };

  BeforeAfter.prototype.onPointerUp = function (event) {
    if (event.pointerId !== this.pointerId) return;
    this.dragging = false;
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);
  };

  function init(scope) {
    var nodes = (scope || document).querySelectorAll('[' + ATTR + ']:not([' + ATTR + '-ready])');
    for (var i = 0; i < nodes.length; i++) new BeforeAfter(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-init when the theme editor swaps a section in.
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
